import React from 'react';
import ContactSection from '../components/home/ContactSection';

const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-[#548B2E] to-[#3f6b20] flex items-center justify-center mt-20">
        <div className="text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl">We'd Love to Hear From You</p>
        </div>
      </section>

      {/* Contact Form */}
      <ContactSection />
    </div>
  );
};

export default Contact;
